// extracted by mini-css-extract-plugin
export var infoRow = "_rq-2";
export var labelContainer = "_rq-0";
export var rightInfo = "_rq-1";